import { render, staticRenderFns } from "./sqmsg.vue?vue&type=template&id=6fc3faf2"
import script from "./sqmsg.vue?vue&type=script&lang=js"
export * from "./sqmsg.vue?vue&type=script&lang=js"
import style0 from "./sqmsg.vue?vue&type=style&index=0&id=6fc3faf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports